export function getEffectiveTotal(total: number, rowsLength: number): number {
  return total > 0 ? total : rowsLength;
}

export function getTotalPages(effectiveTotal: number, pageSize: number): number {
  return Math.max(1, Math.ceil(effectiveTotal / pageSize));
}

export function getPagedRows<T>(rows: readonly T[], page: number, pageSize: number): readonly T[] {
  return rows.slice(page * pageSize, page * pageSize + pageSize);
}

export function getRangeStart(effectiveTotal: number, page: number, pageSize: number): number {
  return effectiveTotal === 0 ? 0 : page * pageSize + 1;
}

export function getRangeEnd(effectiveTotal: number, page: number, pageSize: number): number {
  return Math.min((page + 1) * pageSize, effectiveTotal);
}

/**
 * Páginas visibles para un paginador compacto.
 * - Retorna índices 0-based.
 * - Usa -1 como marcador de ellipsis.
 */
export function getVisiblePages(totalPages: number, currentPage: number): readonly number[] {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i);
  const pages: number[] = [];
  pages.push(0);
  if (currentPage > 2) pages.push(-1); // ellipsis
  for (
    let i = Math.max(1, currentPage - 1);
    i <= Math.min(totalPages - 2, currentPage + 1);
    i++
  ) {
    pages.push(i);
  }
  if (currentPage < totalPages - 3) pages.push(-1); // ellipsis
  pages.push(totalPages - 1);
  return pages;
}

